import { CloseOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import React from 'react';

const RemoveWidget = ({ onClick }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <div>
      <Popconfirm
        title="Remove Widget"
        description="Are you sure you want to remove this widget?"
        onConfirm={handleClick}
        okText="Yes"
        cancelText="No"
        placement="topRight"
      >
        <Button type="text" size="small" icon={<CloseOutlined />} />
      </Popconfirm>
    </div>
  );
};

export default RemoveWidget;
